/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import NotSupportedPageViewCss from "app/preview/react-component/not-supported/presentation/NotSupportedPageView.css";
import React from "react";
import { FormattedMessage } from "react-intl";
import { isIE } from "app/util/AppUtil";
import Branding from "bundle/preview/react-component/header/presentation/branding/Branding";
import ServiceRegistry from "bundle/util/ServiceRegistry";
import AnalyticsConstants from "app/constants/AnalyticsConstants";

const ErrorSVG = `${ window.adobe_dc_sdk.launchOptions.sdkBase }images/error_page_icon.svg`;
export default class NotSupportedPageView extends React.PureComponent {
    constructor() {
        super();
        this._appStore = ServiceRegistry.getService("AppStore");
        ServiceRegistry.getService("AnalyticsProviderService").sendEvent(AnalyticsConstants.SCREEN_BLOCKED);
    }

    render() {
        const appStore = ServiceRegistry.getService("AppStore");
        return (
            <div className={ NotSupportedPageViewCss.notSupportedPage }>
                <div className={ NotSupportedPageViewCss.branding }>
                    <Branding />
                    {
                        !appStore.configStore.getConfig().showBrandingTitle
                        && (
                            <div className={ NotSupportedPageViewCss.name }>
                                <FormattedMessage id="ADOBE_ACROBAT" />
                            </div>
                        )
                    }
                </div>
                <hr className="solid" />
                <div className={ NotSupportedPageViewCss.centered }>
                    <div className={ NotSupportedPageViewCss.imageCss }>
                        <img
                            src={ `${ ErrorSVG }` }
                            alt="browser not supported"
                            className={ NotSupportedPageViewCss.imgIcon }
                        />
                    </div>
                    <div className={ NotSupportedPageViewCss.title_error }>
                        <FormattedMessage
                            id={ isIE() ? "IE11.support.block.header" : "Legacy.Edge.support.block.header" }
                        />
                    </div>
                    <div className={ NotSupportedPageViewCss.subTitle_error }>
                        <FormattedMessage
                            id={ isIE() ? "IE11.support.block.subheader" : "Legacy.Edge.support.block.subheader" }
                        />
                    </div>
                </div>
            </div>
        );
    }
}
